export const HEADER_INVENTORY = "Inventory";
export const HEADER_IVP = "Renewable Fuel Standard";
export const HEADER_FORECASTING = "Forecasting";

export const BREADCRUMBS = {
  BIOVERSE: "Bioverse",
  FORECASTING: "Forecasting",
  UNITED_STATES: "United States",
};
